import { TextFieldWidget } from '@tableau/widgets';
import * as React from 'react';

import { cssClass } from '~src/style';

const rowClassname = cssClass('edit-connection', 'row', {
  width: '100%'
});

export type EditConnectionDialogValueRowProps = Readonly<{
  labelText: string;
  valueText: string | undefined;
  isDisabled: boolean;
  isValid?: boolean;
  testId: string;
  maxLength?: number;
  handleChange: (value: string) => void;
}>;

export function EditConnectionDialogValueRow(props: EditConnectionDialogValueRowProps) {
  return (
    <div className={rowClassname} style={{ paddingTop: '24px' }} >
      <div className={rowClassname}>
        <TextFieldWidget
          className={rowClassname}
          style={{ width: '100%' }}
          onChange={e => props.handleChange(e.target.value)}
          testId={props.testId}
          data-tb-test-id={props.testId}
          value={props.valueText}
          disabled={props.isDisabled}
          maxLength={props.maxLength}
          label={props.labelText}
          valid={(props.isValid === true || props.isValid === undefined) ? undefined : false}
        />
      </div>
    </div>
  );
}
